import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';

import phoneCodesList from 'config/phone-codes';


const phoneCodes = phoneCodesList.map(mask => {
	return {
		...mask,
		search: mask.mask.replace(/[^\d]/g, '')
	}
});


class InputPhone extends Component {
	render() {
		return (
			<MaskedInput
				{...this.props}
				mask={(value) => findMask(value)} />
		)
	}
}

const findMask = (value) => {
	let mask = null;

	for (let i = 4; i > 0; i--) {
		const toFind = (value + '').split('').slice(0, i).join('').replace(/[^\d]/g, '');
		const masks = phoneCodes.filter(mask => mask.search.indexOf(toFind) === 0);
		if (!mask && masks.length) {
			mask = masks[0].mask
		}
	}

	if (!mask)
		return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

	return mask.split('').map(el => {
		return (/[\d#]/g).test(el) ? /\d/ : el
	});
}

export default InputPhone;